import { configureRequest } from '../../../../../networkRequests/apiClient/apiClient.functions'
import urls from '../../../../../networkRequests/apiClient/endpoints'
import { UserRole } from '../../../../../shared/functions/UserRole/userRoleManagement.types'
import {
  ReleaseOfferRequestForAdminErrorResponse,
  ReleaseOfferRequestForAdminRequest,
  ReleaseOfferRequestForAdminSuccessResponse
} from './releaseOfferRequestForAdmin.types'

/**
 * Release offer request for admin
 * @param request - The request object containing offer request ID
 * @returns Promise containing the response
 */
export const releaseOfferRequestForAdminApi = async (
  request: ReleaseOfferRequestForAdminRequest
): Promise<ReleaseOfferRequestForAdminSuccessResponse> => {
  const response = await configureRequest({
    url: urls.offers.releaseOfferRequest,
    method: 'POST',
    data: { offerRequestId: request.offerRequestId },
    headers: {
      'X-User-Role': UserRole.admin
    }
  })

  if (response.status >= 200 && response.status < 300) {
    return response as ReleaseOfferRequestForAdminSuccessResponse
  } else {
    throw response as ReleaseOfferRequestForAdminErrorResponse
  }
}
